import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppUseDispatch, AppUseSelector } from '../../../redux/hooks'
import { SET_EXPERIENCE, SET_IS_RESULT } from '../../../redux/types'
import { trackOnboarding } from '../../../utils/analytics'
import { Glyph } from './icons'
import { StepTitle, StepSubtitle, useLanguageName } from '../stepContext'

const ExperienceStep = ({ next }: { next: () => void }) => {
  const { t } = useTranslation('onboarding')
  const dispatch = AppUseDispatch()
  const { experience, languageInfo } = AppUseSelector(({ onboarding }) => onboarding)
  const languageName = useLanguageName(languageInfo?.language)

  const select = (value: 'yes' | 'no') => {
    dispatch({ type: SET_EXPERIENCE, payload: value })
    // legacy flag still read by the result step (score vs. fresh-start variant)
    dispatch({ type: SET_IS_RESULT, payload: value === 'yes' })
    trackOnboarding('experience_answered', { experience: value })
    next()
  }

  return (
    <div className='ob-step'>
      <StepTitle>{t('experience.title', { language: languageName })}</StepTitle>
      <StepSubtitle>{t('experience.subtitle')}</StepSubtitle>
      <div className='ob-options ob-options--2col'>
        <button
          type='button'
          className={`ob-option ${experience === 'yes' ? 'is-selected' : ''}`}
          onClick={() => select('yes')}
        >
          <Glyph char='会' />
          <span className='ob-option-body'>
            {t('experience.yes.label', { language: languageName })}
            <span className='ob-option-hint'>{t('experience.yes.hint')}</span>
          </span>
        </button>
        <button
          type='button'
          className={`ob-option ${experience === 'no' ? 'is-selected' : ''}`}
          onClick={() => select('no')}
        >
          <Glyph char='新' />
          <span className='ob-option-body'>
            {t('experience.no.label')}
            <span className='ob-option-hint'>{t('experience.no.hint')}</span>
          </span>
        </button>
      </div>
    </div>
  )
}

export default ExperienceStep
